import type { RouteRecordRaw } from 'vue-router';

export const invoicesRoutes: RouteRecordRaw[] = [
  {
    path: 'invoices',
    name: 'invoices',
    component: () => import('./pages/InvoicesListPage.vue'),
    meta: { title: 'Invoices', requiresAuth: true, permission: 'view_sales' },
  },
  {
    path: 'invoices/new',
    name: 'invoices.create',
    component: () => import('./pages/InvoiceEditorPage.vue'),
    meta: { title: 'New invoice', requiresAuth: true, permission: 'create_sales' },
  },
  // Batch invoice import ("Import with AI") — declared before `invoices/:id`
  // so the static segments win the match.
  {
    path: 'invoices/import',
    name: 'invoices.import',
    component: () => import('./pages/ImportInvoicesPage.vue'),
    meta: { title: 'Import invoices', requiresAuth: true, permission: 'import_sales' },
  },
  {
    path: 'invoices/imports',
    name: 'invoices.imports',
    component: () => import('./pages/ImportHistoryPage.vue'),
    meta: { title: 'Import history', requiresAuth: true, permission: 'import_sales' },
  },
  {
    path: 'invoices/imports/:id',
    name: 'invoices.imports.show',
    component: () => import('./pages/ImportBatchDetailPage.vue'),
    meta: { title: 'Import batch', requiresAuth: true, permission: 'import_sales' },
  },
  {
    path: 'invoices/:id',
    name: 'invoices.show',
    component: () => import('./pages/InvoiceDetailPage.vue'),
    meta: { title: 'Invoice', requiresAuth: true, permission: 'view_sales' },
  },
];
